import { Link } from 'react-router-dom';
import './assets/css/footer.css';
import { Mini1WaitLocation, Mini1WaitPhone, Mini1WaitPost, MiniBlackFaceBook, MiniBlackInstagram, MiniBlackTelegram, MiniBlackWhatsapp } from '../assets/icones/icones';
import logo_footer from '../assets/images/logo-footer.svg'
import {Fragment, useEffect, useState} from "react";
import {Agent_address_get_data, empty_bk} from "../clientconfigwebapp";


const Footer = () => {


    const [address_agent_text , set_address_agent_text] = useState('');

    const [phone_number_agent_text , set_phone_number_agent_text] = useState('');

    useEffect(() => {

        var agent_name_bon=Agent_address_get_data("address_agent");
        var phone_number_agent_bon=Agent_address_get_data("phone_number_agent");

        if(!empty_bk(agent_name_bon)){
            set_address_agent_text(agent_name_bon);
        }

        if(!empty_bk(phone_number_agent_bon)){
            set_phone_number_agent_text(phone_number_agent_bon);
        }




    });





    return (
        <Fragment>
            <footer style={{"borderRadius":"1.25rem","background":"rgb(42, 38, 33)","marginRight":"2%","marginLeft":"2%","marginBottom":"36px"}}>
                <div className="flexRowBetCenter footer">
                    <ul style={{
                        "display": "flex",
                        "flexDirection": "column",
                        "alignContent": "flex-start",
                        "justifyContent": "center",
                        "alignItems": "flex-start"
                    }}>
                        <li>
                            <Mini1WaitLocation/>
                            <span>{String(address_agent_text)}</span>

                        </li>
                        <li>
                            <Mini1WaitPhone/>
                            <a href={"tel:" + String(phone_number_agent_text)}><span>{String(phone_number_agent_text)}</span></a>

                        </li>
                        <li>
                            <Mini1WaitPost/>
                            <a href={"mailto:Boncoffeetakeaway@gmail.com"}> <span>Boncoffe@gmail.com</span></a>

                        </li>
                    </ul>


                    <Link to={"/"}> <img className={"logo-footer-karimian"} src={logo_footer} alt="logo-footer"/></Link>

                    <ul className='flexRowBetCenter'>
                        <li className={"footer-telegram"}>
                            <Link to="/">
                                <MiniBlackTelegram/>
                            </Link>
                        </li>
                        <li className={"footer-telegram"}>
                            <Link to="/">
                                <MiniBlackFaceBook/>
                            </Link>
                        </li>
                        <li className={"footer-watsapp"}>
                            <Link to="/">
                                <MiniBlackWhatsapp/>
                            </Link>
                        </li>
                        <li className={"footer-instagram"}>
                            <a href="https://instagram.com/boncoffee.takeaway?igshid=MzRlODBiNWFlZA==">
                                <MiniBlackInstagram/>
                            </a>
                        </li>
                    </ul>




                </div>


                <div className={"enamad-footer"}>
                    <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=483590&Code=QFUhugy6byjrq41rfZ6XOouze6g5qJw5"
                    >
                        <img
                            referrerPolicy="origin"
                            src="https://trustseal.enamad.ir/logo.aspx?id=483590&Code=QFUhugy6byjrq41rfZ6XOouze6g5qJw5"
                            alt=""
                            style={{cursor: "pointer"}}
                            code="QFUhugy6byjrq41rfZ6XOouze6g5qJw5"
                        />
                    </a>

                </div>
                <div style={{
                    "paddingBottom": "20px",
                    "paddingTop": "14px",
                    "textAlign": "center",
                    "color": "white",
                    "fontSize": "11px",
                    "display": "block",
                    "lineHeight": "1.6",
                    "borderTop": "solid 1px #c4c3c336"
                }}>کلیه حقوق مادی و معنوی این سایت متعلق به شرکت بن کافی است.طراحی توسط <a target="_blank"
                                                                                           className="text-svg-hover-orange-bk"
                                                                                           href="https://rayanitco.com/"
                                                                                           title="رایان"
                                                                                           style={{color: 'white'}}> رایان </a>
                </div>






            </footer>

        </Fragment>
    )
}
export default Footer;